import { BrowserRouter } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';

import { FeatureFlagsProvider } from '@project44/feature-flags';
import { ReactHooksApplication } from '@project44/iam-team-ui-utils';
import { RequireTranslations } from '@project44/translations-utils';
import { useUser } from '@project44/ui-utils';

import { translations } from '../l10n/config';
import { SideBar, Skeleton } from './movement';
import { PACKAGE_NAME } from './utils/constants/PACKAGE_NAME';

export function App() {
  const { tenantHookController } = ReactHooksApplication.getInstance();
  const { data } = useUser();

  const [TenantSwitcherComponent, toggleTenantSwitcherComponent] =
    tenantHookController.composeUseToggleTenantSwitcherComponent({
      user: data,
    })();

  return (
    <BrowserRouter>
      <CompatRouter>
        <SideBar
          toggleTenantSwitcherComponent={toggleTenantSwitcherComponent}
        />
        <TenantSwitcherComponent />
      </CompatRouter>
    </BrowserRouter>
  );
}

export default function AppProvider() {
  return (
    <RequireTranslations namespace={PACKAGE_NAME} translations={translations}>
      <FeatureFlagsProvider loadingComponent={<Skeleton />}>
        <App />
      </FeatureFlagsProvider>
    </RequireTranslations>
  );
}
